<template>
	<div>
		<div class="d-flex">
			<v-row>
				<v-col cols="3">
					<datePicker v-model="filtros.Desde" format="YYYY-MM-DD" :maxDate="filtros.Hasta" label="Desde (Obligatorio)"
						:loading="loadingMatriz" :disabled="loadingMatriz" />
				</v-col>
				<v-col cols="3">
					<datePicker v-model="filtros.Hasta" format="YYYY-MM-DD" :minDate="filtros.Desde" label="Hasta (Obligatorio)"
						:loading="loadingMatriz" :disabled="loadingMatriz" />
				</v-col>
				<v-col cols="3">
					<v-autocomplete v-model="filtros.Instancias" :items="instancias" :item-text="nombreMaquina"
						item-value="idMaquinaIns" multiple label="Máquinas (Obligatorio)" chips :loading="loadingMatriz"
						:disabled="loadingMatriz" clearable />
				</v-col>
				<v-col cols="3">
					<v-autocomplete v-model="filtros.Turnos" :items="turnos" item-text="nombre" item-value="idTurno" multiple
						label="Turnos (Obligatorio)" chips :loading="loadingMatriz" :disabled="loadingMatriz" clearable />
				</v-col>
			</v-row>
		</div>
		<div class="d-flex align-center">
			<CountDownSearch v-if="yaConsultado" v-model="consultaLista" :pausado="cuentaPausada" :duracion-segundos="300"
				:recordarProgreso="true" :recargando="loadingMatriz" @recargaManual="getMatriz()" />
			<v-spacer></v-spacer>
			<FilterSyncIndicator :expectedFilters="filtros" :appliedFilters="ultimosFiltros" class="mr-2" />
			<v-btn color="primary" @click="getMatriz()" :loading="loadingMatriz" :disabled="!filtrosValidos">Consultar</v-btn>
			<v-btn
				color="success"
				class="ml-2"
				@click="descargarExcel()"
				:loading="loadingExcel"
				:disabled="loadingMatriz || loadingExcel || !filtrosValidos"
			>
				Descargar Excel
			</v-btn>
		</div>
		<LoaderData :loading="loadingMatriz" :response="datos" :error="errorMatriz">
			<TablaMatriz :maquinas="datos" />
		</LoaderData>
		<VisibilitySignal @deactivated="pausarBusqueda()" @activated="reanudarBusqueda()" />
	</div>
</template>

<script>
import axios from 'axios';
import CountDownSearch from '../../../CountDownSearch.vue';
import TablaMatriz from './TablaMatriz.vue';
import LoaderData from '../../../LoaderData.vue';
import FilterSyncIndicator from '../../../FilterSyncIndicator.vue';
import VisibilitySignal from '../../../VisibilitySignal.vue';

export default {
	components: {
		CountDownSearch,
		TablaMatriz,
		LoaderData,
		FilterSyncIndicator,
		VisibilitySignal,
	},
	data() {
		return {
			datos: [],
			instancias: [],
			turnos: [],

			errorMatriz: false,
			filtros: {
				Desde: null,
				Hasta: null,
				Instancias: [],
				Turnos: [],
			},
			ultimosFiltros: {
				Desde: null,
				Hasta: null,
				Instancias: [],
				Turnos: [],
			},

			loadingInstancias: false,
			loadingTurnos: false,
			loadingMatriz: false,
			loadingExcel: false,

			yaConsultado: false,
			cuentaPausada: false,
			consultaLista: true,
		}
	},
	methods: {
		nombreMaquina: (maquina) => `[${maquina.nombre}] - ${maquina.marca} ${maquina.modelo}`,

		crearParamsMatriz() {
			const params = new URLSearchParams();

			// IdMaquinaIns (repetido)
			(this.filtros.Instancias || []).forEach(id => {
				if (id !== null && id !== undefined && id !== "") params.append("IdMaquinaIns", id);
			});

			// Fechas (YYYY-MM-DD)
			const toYMD = v => {
				if (!v) return null;
				if (typeof v === "string") return v.slice(0, 10);
				if (v instanceof Date) return v.toISOString().slice(0, 10);
				return String(v).slice(0, 10);
			};

			const desde = toYMD(this.filtros.Desde);
			const hasta = toYMD(this.filtros.Hasta);
			if (desde) params.append("Desde", desde);
			if (hasta) params.append("Hasta", hasta);
			params.append("MantenerPrediccionEstado", false);

			// Turnos (si existe en filtros: Turnos o IdsTurnos)
			const turnos = this.filtros.Turnos || [];
			(turnos || []).forEach(id => {
				if (id !== null && id !== undefined && id !== "") params.append("IdsTurnos", id);
			});

			return params;
		},
		obtenerNombreExcelMatriz() {
			const fecha = String(this.filtros.Desde || '').slice(0, 10);
			const [anio, mes] = fecha.split('-');

			return `Reporte Matriz Maquinas ${mes || 'mes'}-${anio || 'año'}.xlsx`;
		},

		getMatriz() {
			if (!this.yaConsultado) this.yaConsultado = true;
			this.loadingMatriz = true;
			this.errorMatriz = false;

			const params = this.crearParamsMatriz();
			const url = `OEECalculos/ReporteMatrizOptimizadov?${params.toString()}`;

			axios
				.get(url)
				.then(response => {
					this.datos = response.data;
					this.ultimosFiltros = (typeof structuredClone === "function")
						? structuredClone(this.filtros)
						: JSON.parse(JSON.stringify(this.filtros));
				})
				.catch(() => { this.errorMatriz = true; })
				.finally(() => { this.loadingMatriz = false; });
		},
		descargarExcel() {
			this.loadingExcel = true;

			const params = this.crearParamsMatriz();
			const url = `OEECalculos/ReporteMatrizOptimizadovExcel?${params.toString()}`;

			axios
				.get(url, { responseType: 'blob' })
				.then(response => {
					const blob = new Blob(
						[response.data],
						{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
					);

					const blobURL = URL.createObjectURL(blob);
					const link = document.createElement('a');

					link.href = blobURL;
					link.download = this.obtenerNombreExcelMatriz();

					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

					URL.revokeObjectURL(blobURL);
				})
				.catch(() => {
					this.$toast?.error?.('No se pudo descargar el reporte de matriz OEE');
				})
				.finally(() => {
					this.loadingExcel = false;
				});
		},
		getInstancias() {
			this.loadingInstancias = true;
			axios
				.get('/MaquinaInstancias')
				.then(res => (this.instancias = res.data))
				.catch(err => console.log(err))
				.finally(() => {
					this.loadingInstancias = false;
				});
		},
		getTurnos() {
			this.loadingTurnos = true;
			axios
				.get('/Turnos')
				.then(res => (this.turnos = res.data))
				.catch(err => console.log(err))
				.finally(() => {
					this.loadingTurnos = false;
				});
		},

		initialice() {
			this.getInstancias();
			this.getTurnos();
		},

		pausarBusqueda() {
			this.cuentaPausada = true;

		},
		reanudarBusqueda() {
			this.cuentaPausada = false;

		}
	},
	computed: {
		filtrosValidos() {
			const desde = this.filtros?.Desde ? new Date(this.filtros.Desde) : null;
			const hasta = this.filtros?.Hasta ? new Date(this.filtros.Hasta) : null;

			const fechasValidas =
				desde instanceof Date && !isNaN(desde) &&
				hasta instanceof Date && !isNaN(hasta) &&
				desde.getTime() <= hasta.getTime();

			const tieneTurnos = Array.isArray(this.filtros?.Turnos) && this.filtros.Turnos.length > 0;
			const tieneMaquinas = Array.isArray(this.filtros?.Instancias) && this.filtros.Instancias.length > 0;

			return fechasValidas && tieneTurnos && tieneMaquinas;
		},
	},
	mounted() {
		this.initialice();
	},
}
</script>